<template>
  <div class="lock-ticket">
    <div class="content">
<!--      <a href="https://if.geekpark.net/ticketcenter/" target="_blank">-->
      <a href="https://events.geekpark.net/orders/index/cn/if20" target="_blank">
<!--        <img src="https://summit-img.geekpark.net/ifx/images/%E5%AE%98%E7%BD%91-%E8%B4%AD%E7%A5%A8%E4%B8%AD%E5%BF%83-V2.jpg" alt="">-->
        <img src="https://summit-img.geekpark.net/ifx/pc/2020%E9%A2%84%E5%94%AE%E7%A5%A8v2.jpg" alt="">
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LockTicket'
}
</script>

<style scoped lang="less">
  .lock-ticket {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    margin:0 14vh 0 14vh;
  }

  .content {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    box-sizing: border-box;
    width: 125vh;
    height: 100vh;
    position: relative;
  }
  a{
    height: 100%;
    img{
      height: 100%;
    }
  }
</style>
